import { defaultTo } from 'lodash';
import {
  IModel,
  Model,
  ModelRecord,
  SalesItemOptionModel,
} from '@common/models';

export interface ISalesPackageContentModel extends IModel {
  salesPackageContentId: number;
  salesPackageId: number;
  salesItemOptionId: number;
  sortOrder: number;
  salesItemId: number;
  salesItemName: string;
  salesItemOption: SalesItemOptionModel;
}

export class SalesPackageContentModel
  extends Model
  implements ModelRecord<ISalesPackageContentModel>
{
  salesPackageContentId: number;
  salesPackageId: number;
  salesItemOptionId: number;
  sortOrder: number;
  salesItemId: number;
  salesItemName: string;
  salesItemOption: SalesItemOptionModel;
  constructor(params?: Partial<ISalesPackageContentModel>) {
    super(params);
    this.salesPackageContentId = defaultTo(params?.salesPackageContentId, 0);
    this.salesPackageId = defaultTo(params?.salesPackageId, 0);
    this.salesItemOptionId = defaultTo(params?.salesItemOptionId, 0);
    this.salesItemName = defaultTo(params?.salesItemName, '');
    this.salesItemId = defaultTo(params?.salesItemId, 0);
    this.sortOrder = defaultTo(params?.sortOrder, 0);
    this.salesItemOption = params?.salesItemOption
      ? new SalesItemOptionModel(params.salesItemOption)
      : new SalesItemOptionModel();
  }
}
